export const getters = {
    starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
    navbarSearchAndPinList: state => state.navbarSearchAndPinList,
    sidebarWidth: state => state.sidebarWidth,
    bodyOverlay: state => state.bodyOverlay,
    isSidebarActive: state => state.isSidebarActive,
    isThemeDark: state => state.theme === 'dark',
    breakpoint: state => state.breakpoint,
    isLoggedIn: state => !!state.authToken,
    authToken: state => state.authToken,
    currentUser: state => state.currentUser,
    idUser: state => state.currentUser.id_pessoa,
    roleUser: state => state.currentUser.usuario_cargo,
    daterange: state => state.daterange,
    relatorioComissoes: state => state.relatorioComissoes,
    relatorioTickets: state => state.relatorioTickets,
    dashboard: state => state.dashboard,
    token: state => state.authToken,
    usuario: state => state.currentUser,
    usuarios: state => state.usuarios,
    usuariosAtivos: state => state.usuarios.filter(usuario => usuario.ativo === 1),
    programadores: state => state.usuarios.filter(usuario => usuario.ativo === 1 && [2, 4, 5, 6].includes(usuario.usuario_cargo)),
    testers: state => state.usuarios.filter(usuario => usuario.ativo === 1 && [7, 8, 9].includes(usuario.usuario_cargo)),
    time_apoio: state => state.usuarios.filter(usuario => usuario.ativo === 1 && [10, 11, 12].includes(usuario.usuario_cargo)),
    analistas: state => state.usuarios.filter(usuario => usuario.ativo === 1 && [2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 17, 18, 19, 20, 21, 22, 23].includes(usuario.usuario_cargo)),
    isManager: state => [1, 2].includes(state.currentUser.usuario_cargo),
    isTester: state => [7, 8, 9].includes(state.currentUser.usuario_cargo),
    requisitions: state => state.axios_req,
    theme: state => state.theme,
};
